//
// DateConstraint.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractValueConstraintType";
import "./RelativeAllowed";
import "../BIRDDataType";
import "../values/ValueBehavior";
import "../../promptDefinitions/PromptDefinition";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataUsage";

var DateConstraint = createModule("BIRD::DateConstraint", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractConstraintType","BIRD::AbstractValueConstraintType"], EventDispatcher, [
    ,
    {
        minValueRef: 1,
        maxValueRef: 1,
        minBehavior: 4,
        dataType: 4,
        maxBehavior: 4,
        relativeAllowed: 4,
    },
    ,
    ,
    {
        getDataUsage: [4],
    },
    {
        _create: [4],
    },
    ,
]);
export default DateConstraint;
